/**
 * Данные о теплофизических свойствах строительных материалов
 * 
 * conductivity - коэффициент теплопроводности материала (Вт/(м·°C))
 * density - плотность материала (кг/м³)
 * thickness - типовая толщина материала (м)
 */

export const buildingMaterials = {
    // Стеновые материалы
    walls: {
      // Кирпичные конструкции
      'brick_noninsulated': {
        name: 'Кирпич без утепления',
        conductivity: 0.7,
        density: 1800,
        thickness: 0.51 // 2 кирпича
      },
      'brick_insulated': {
        name: 'Кирпич с утеплителем',
        conductivity: 0.7,
        density: 1800,
        thickness: 0.51 // 2 кирпича + утеплитель
      },
      
      // Бетонные конструкции
      'concrete_noninsulated': {
        name: 'Бетон без утепления',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2
      },
      'concrete_insulated': {
        name: 'Бетон с утеплителем',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2 // + утеплитель
      },
      'reinforced_concrete': {
        name: 'Железобетонные панели',
        conductivity: 1.7,
        density: 2500,
        thickness: 0.16
      },
      
      // Деревянные конструкции
      'wood_log': {
        name: 'Бревно',
        conductivity: 0.15,
        density: 500,
        thickness: 0.2
      },
      'wood_timber': {
        name: 'Брус',
        conductivity: 0.14,
        density: 500,
        thickness: 0.15
      },
      'wood_frame': {
        name: 'Каркасная конструкция',
        conductivity: 0.1,
        density: 200,
        thickness: 0.15 // + утеплитель
      },
      
      // Другие материалы
      'aerated_concrete': {
        name: 'Газобетон/пенобетон',
        conductivity: 0.12,
        density: 600,
        thickness: 0.3
      },
      'foam_blocks': {
        name: 'Пенополистирольные блоки',
        conductivity: 0.05,
        density: 150,
        thickness: 0.3
      },
      'ceramic_blocks': {
        name: 'Керамические блоки',
        conductivity: 0.14,
        density: 800,
        thickness: 0.38
      }
    },
    
    // Теплоизоляционные материалы
    insulation: {
      'none': {
        name: 'Без утеплителя',
        conductivity: 1.0,
        density: 0,
        thickness: 0
      },
      'mineral_wool': {
        name: 'Минеральная вата',
        conductivity: 0.04,
        density: 100,
        thickness: 0.1
      },
      'glass_wool': {
        name: 'Стекловата',
        conductivity: 0.044,
        density: 15,
        thickness: 0.1
      },
      'eps': {
        name: 'Пенополистирол (EPS)',
        conductivity: 0.038,
        density: 25,
        thickness: 0.1
      },
      'xps': {
        name: 'Экструдированный пенополистирол (XPS)',
        conductivity: 0.03,
        density: 35,
        thickness: 0.1
      },
      'ppu': {
        name: 'Пенополиуретан (ППУ)',
        conductivity: 0.022,
        density: 40,
        thickness: 0.1
      },
      'eco_wool': {
        name: 'Эковата',
        conductivity: 0.04,
        density: 65,
        thickness: 0.1
      }
    },
    
    // Кровельные/потолочные материалы
    roofs: {
      'concrete_noninsulated': {
        name: 'Железобетон без утепления',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2
      },
      'concrete_insulated': {
        name: 'Железобетон с утеплителем',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2 // + утеплитель
      },
      'wood_noninsulated': {
        name: 'Деревянное перекрытие без утепления',
        conductivity: 0.15,
        density: 500,
        thickness: 0.2
      },
      'wood_insulated': {
        name: 'Деревянное перекрытие с утеплителем',
        conductivity: 0.15,
        density: 500,
        thickness: 0.2 // + утеплитель
      }
    },
    
    // Материалы для пола/перекрытий
    floors: {
      'concrete_noninsulated': {
        name: 'Железобетон без утепления',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2
      },
      'concrete_insulated': {
        name: 'Железобетон с утеплителем',
        conductivity: 1.5,
        density: 2400,
        thickness: 0.2 // + утеплитель
      },
      'wood_noninsulated': {
        name: 'Деревянное перекрытие без утепления',
        conductivity: 0.15,
        density: 500,
        thickness: 0.2
      },
      'wood_insulated': {
        name: 'Деревянное перекрытие с утеплителем',
        conductivity: 0.15,
        density: 500,
        thickness: 0.2 // + утеплитель
      }
    }
  };